import React, { Component } from "react";
import {FaTwitter ,FaInstagram ,FaFacebookF , FaLinkedinIn} from "react-icons/fa";
import { LanguageContext } from '../../context/LanguageContext';
import translations from '../../translations';

const SocialShare = [
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/massDevelop'},
    {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/company/mass-dev/'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/mass.develop/'},
    // {Social: <FaTwitter /> , link: 'https://twitter.com/'},
]

class Footer extends Component{
    static contextType = LanguageContext;

    render(){
        const { language } = this.context;
        const t = translations[language];

        return(
            <React.Fragment>
                <footer className="footer-area">
                    <div className="footer-wrapper">
                        <div className="row align-items-end row--0">
                            <div className="col-lg-6">
                                <div className="footer-left">
                                    <div className="inner">
                                        <span>{t.footer.readyText}</span>
                                        <h2>{t.footer.heading}</h2>
                                        <a className="rn-button-style--2" href="/contact">
                                            <span>{t.footer.contactButton}</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="footer-right" data-black-overlay="6">
                                    <div className="row">
                                        {/* Start Single Widget  */}
                                        <div className="col-lg-6 col-sm-6 col-12">
                                            <div className="footer-link">
                                                <h4>{t.footer.quickLink.title}</h4>
                                                <ul className="ft-link">
                                                    {/* <li><a href="/team">{t.footer.quickLink.team}</a></li> */}
                                                    <li><a href="/creative-agency">{t.footer.quickLink.explore}</a></li>
                                                    <li><a href="/explore">{t.footer.quickLink.projects}</a></li>
                                                    <li><a href="/">{t.footer.quickLink.home}</a></li>
                                                    <li><a href="/contact">{t.footer.quickLink.letsTalk}</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                        {/* End Single Widget  */}
                                        {/* Start Single Widget  */}
                                        <div className="col-lg-6 col-sm-6 col-12 mt_mobile--30">
                                            <div className="footer-link">
                                                <h4>{t.footer.sayHello.title}</h4>
                                                <ul className="ft-link">
                                                    <li><a href="mailto:mass.dev100@gmail.com">mass.dev100@gmail.com</a></li>
                                                    {/* <li><a href="mailto:hr@example.com">hr@example.com</a></li> */}
                                                </ul>

                                                <div className="social-share-inner">
                                                    <ul className="social-share social-style--2 d-flex justify-content-start liststyle mt--15">
                                                        {SocialShare.map((val , i) => (
                                                            <li key={i}><a href={`${val.link}`}>{val.Social}</a></li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Widget  */}

                                        <div className="col-lg-12">
                                            <div className="copyright-text">
                                                <p>{t.footer.copyright} | <a href="/privacy-policy" style={{color: '#c6c9d8', textDecoration: 'underline'}}>Privacy Policy</a></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </React.Fragment>
        )
    }
}
export default Footer;